import { Card, CardContent } from '@/components/ui/card';
import { Sparkles } from 'lucide-react';

/**
 * Placeholder page for ERP modules that are queued for Phase 2+.
 * Renders a friendly "Coming soon" card so the sidebar remains navigable.
 */
export default function ComingSoon({ title, description, phase = 'Phase 2' }) {
  return (
    <div className="max-w-2xl mx-auto py-16" data-testid="erp-coming-soon">
      <Card>
        <CardContent className="p-10 text-center">
          <Sparkles className="h-10 w-10 text-brand-orange mx-auto mb-3" />
          <h1 className="font-heading text-2xl font-bold text-gray-900">{title}</h1>
          <p className="text-gray-500 mt-2 max-w-md mx-auto">
            {description || 'This module is queued for build. Everything you set up now in Phase 1 (buildings, units, tenants, EMI customers) will flow through seamlessly.'}
          </p>
          <p className="mt-6 inline-block text-xs bg-orange-100 text-brand-rust font-semibold px-3 py-1 rounded-full">
            {phase} · Coming soon
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
